import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const Wrapper = withViewportStyle("div")`
  padding: ${rem(80)} ${rem(140)};

  ${(props) => props.$viewport.tablet`
    padding: ${rem(80)} ${rem(16)};
  `}
  
  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)};
  `}
`;
